import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, NavLink, Redirect } from 'react-router-dom';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import BusinessEstablishment from './BusinessEstablishment';
import Chairman from './Chairman';
import Citizenship from './Citizenship';
import Hospital from './Hospital';
import Institution from './Institution';
import Profession from './Profession';
import Requirement from './Requirement';

function CSVUploadContainer({ match }) {
  const permissions = getJson('permissions');
  
  return (
    <div className="module-inner">
      <div className="module-inner-title">CSV Upload</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW CSV UPLOAD BUSINESS ESTABLISHMENT']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/general-settings/csv-upload/business-establishment"
          >
            Business Establishment
          </NavLink>
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD CHAIRMAN']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/general-settings/csv-upload/chairman"
          >
            Chairman
          </NavLink>
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD CITIZENSHIP']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/general-settings/csv-upload/citizenship"
          >
            Citizenship
          </NavLink>
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD HOSPITAL']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/general-settings/csv-upload/hospital"
          >
            Hospital
          </NavLink>
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD INSTITUTION']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/general-settings/csv-upload/institution"
          >
            Institution
          </NavLink>
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD PROFESSION']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/general-settings/csv-upload/profession"
          >
            Profession
          </NavLink>
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD REQUIREMENT']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/general-settings/csv-upload/requirement"
          >
            Requirement
          </NavLink>
        )}
      </div>

      <Switch>
        {Acl(permissions, ['VIEW CSV UPLOAD BUSINESS ESTABLISHMENT']) && (
          <Route
            exact
            path="/general-settings/csv-upload"
            render={() => <Redirect to="/general-settings/csv-upload/business-establishment" />}
          />
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD BUSINESS ESTABLISHMENT']) && (
          <Route path={`${match.path}/business-establishment`} component={BusinessEstablishment} />
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD CHAIRMAN']) && (
          <Route path={`${match.path}/chairman`} component={Chairman} />
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD CITIZENSHIP']) && (
          <Route path={`${match.path}/citizenship`} component={Citizenship} />
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD HOSPITAL']) && (
          <Route path={`${match.path}/hospital`} component={Hospital} />
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD INSTITUTION']) && (
          <Route path={`${match.path}/institution`} component={Institution} />
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD PROFESSION']) && (
          <Route path={`${match.path}/profession`} component={Profession} />
        )}
        {Acl(permissions, ['VIEW CSV UPLOAD REQUIREMENT']) && (
          <Route path={`${match.path}/requirement`} component={Requirement} />
        )}
      </Switch>
    </div>
  );
}


CSVUploadContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};


export default CSVUploadContainer;
